import { Component, OnInit, Input, ChangeDetectorRef, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormControl, FormsModule } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, } from 'ng2-date-picker';
import { NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTimepickerModule } from 'mat-timepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';

class CustomErrorStateMatcher implements ErrorStateMatcher {
        isErrorState(control: UntypedFormControl | null) {
          return control.invalid;
        }
      }
@Component({
    selector: 'app-clock-time-picker',
    templateUrl: './clock-time-picker.component.html',
    styleUrls: ['./clock-time-picker.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatFormFieldModule,
        MatTimepickerModule,
        FormsModule,
        MatIconModule,
        NgIf,
    ],
})
export class ClockTimePickerComponent implements OnInit {
    constructor(private ref: ChangeDetectorRef, private fb: UntypedFormBuilder) {}

    //service item data
    @Input() product;

    availableFrom: Date;

    availableTo: Date;

    @Input() selected = Date();

    @Input()time = this.fb.control('');

        onSelect(data) {
            let date = new Date(data);
            this.time.setValue(moment(date, 'HH:mm:ss'));
          }

          customErrorStateMatcher = new CustomErrorStateMatcher();

    initTime = () => {

        try {
            if (this.product?.time[0]?.start && this.product?.time[0]?.end){

                //this.availableFrom = new Date(this.product?.time[0]?.start);
                //this.availableTo =  new Date(this.product?.time[0]?.end);
                this.availableFrom = moment(this.product?.time[0]?.start, 'HH:mm:ss').isValid()?moment(this.product?.time[0]?.start, 'HH:mm:ss').toDate():moment().toDate();
                this.availableTo =  moment(this.product?.time[0]?.end, 'HH:mm:ss').isValid()?moment(this.product?.time[0]?.end, 'HH:mm:ss').toDate():moment().toDate();

            }
        } catch (error) {
            console.log(
                'Error initing Time Picker: ' + error?.toString()
            );
        }
    };

    ngOnInit(): void {
        this.initTime();
    }


}
